import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import baoCaoCoSoLaoDong from "@/pages/BaoCaoCoSoLaoDong.vue";
import DonViPage from "@/pages/DonViPage.vue";
import registerPage from "@/pages/RegisterPage.vue";
import userList from "@/pages/UserList.vue";
import baoCaoHoatDongYTeTuyenHuyen from "@/pages/BaoCaoHoatDongYTeTuyenHuyen.vue";
import baoCaoHoatDongYTeKiemDichThang from "@/pages/BaoCaoHoatDongYTeKiemDichThang.vue";
import baoCaoCongTacYTeTruongHoc from "@/pages/BaoCaoCongTacYTeTruongHoc.vue";
import baoCaoKetQuaKiemTraVSNuocSach from "@/pages/BaoCaoKetQuaKiemTraVSNuocSach.vue";
import baoCaoThongKeTiemVacxin from "@/pages/BaoCaoThongKeTiemVacxin.vue";
import baoCaoThongKeTinhHinhSDVacxin from "@/pages/BaoCaoThongKeTinhHinhSDVacxin.vue";
import baoCaoSanLocBenhKLNVaKSK from "@/pages/BaoCaoSanLocBenhKLNVaKSK.vue";
import updatePasswordPage from "@/pages/UpdatePasswordPage.vue";
import BaoCaoHoatDongYTeKiemDichThangDaGoi from "@/pages/BaoCaoHoatDongYTeKiemDichThangDaGoi.vue";
import BaoCaoSanLocBenhKLNVaKSKDaGoi from "@/pages/BaoCaoSanLocBenhKLNVaKSKDaGoi.vue";
import baoCaoThongKeTinhHinhSDVacxinDaGoi from "@/pages/BaoCaoThongKeTinhHinhSDVacxinDaGoi.vue";
import baoCaoCoSoLaoDongDaGoi from "@/pages/BaoCaoCoSoLaoDongDaGoi.vue";
import baoCaoHoatDongYTeTuyenHuyenDaGoi from "@/pages/BaoCaoHoatDongYTeTuyenHuyenDaGoi.vue";
import baoCaoThongKeTiemVacxinDaGoi from "@/pages/BaoCaoThongKeTiemVacxinDaGoi.vue";
import baoCaoCongTacYTeTruongHocDaGoi from "@/pages/BaoCaoCongTacYTeTruongHocDaGoi.vue";
import baoCaoKetQuaKiemTraVSNuocSachDaGoi from "@/pages/BaoCaoKetQuaKiemTraVSNuocSachDaGoi.vue";

const routes: Array<RouteRecordRaw> = [
  // {
  //   path: '/',
  //   name: '',
  //   component: chartPage,
  //   props: true
  // },
  {
    path: '/baoCaoSanLocDaGoi',
    name: 'BaoCaoSanLocBenhKLNVaKSKDaGoi',
    component: BaoCaoSanLocBenhKLNVaKSKDaGoi,
    props: true
  },
  {
    path: '/baoCaoTinhHinhDaGoi',
    name: 'baoCaoTinhHinhDaGoi',
    component: baoCaoThongKeTinhHinhSDVacxinDaGoi,
    props: true
  },
  {
    path: '/baoCaoHDYTKDDaGoi',
    name: 'BaoCaoHoatDongYTeKiemDichThangDaGoi',
    component: BaoCaoHoatDongYTeKiemDichThangDaGoi,
    props: true
  },
  {
    path: '/baoCaoCoSoLaoDong',
    name: 'baoCaoCoSoLaoDong',
    component: baoCaoCoSoLaoDong,
    props: true
  },
  {
    path: '/baoCaoCoSoLaoDongDaGoi',
    name: 'baoCaoCoSoLaoDongDaGoi',
    component: baoCaoCoSoLaoDongDaGoi,
    props: true
  },
  {
    path: '/baoCaoKQVSNuocSach',
    name: 'baoCaoKQVSNuocSach',
    component: baoCaoKetQuaKiemTraVSNuocSach,
    props: true
  },
  {
    path: '/baoCaoKQVSNuocSachDaGoi',
    name: 'baoCaoKQVSNuocSachDaGoi',
    component: baoCaoKetQuaKiemTraVSNuocSachDaGoi,
    props: true
  },
  {
    path: '/baoCaoCongTacYTeTruongHoc',
    name: 'baoCaoCongTacYTeTruongHoc',
    component: baoCaoCongTacYTeTruongHoc,
    props: true
  },
  {
    path: '/baoCaoCongTacYTeTruongHocDaGoi',
    name: 'baoCaoCongTacYTeTruongHocDaGoi',
    component: baoCaoCongTacYTeTruongHocDaGoi,
    props: true
  },
  {
    path: '/baoCaoTuyenHuyen',
    name: 'baoCaoHoatDongYTeTuyenHuyen',
    component: baoCaoHoatDongYTeTuyenHuyen,
    props: true
  },
  {
    path: '/baoCaoTuyenHuyenDaGoi',
    name: 'baoCaoHoatDongYTeTuyenHuyenDaGoi',
    component: baoCaoHoatDongYTeTuyenHuyenDaGoi,
    props: true
  },
  {
    path: '/baoCaoKiemDichYTe',
    name: 'baoCaoHDKDThang',
    component: baoCaoHoatDongYTeKiemDichThang,
    props: true
  },
  {
    path: '/baoCaoVacxin',
    name: 'baoCaoVacxin',
    component: baoCaoThongKeTiemVacxin,
    props: true
  },
  {
    path: '/baoCaoVacxinDaGoi',
    name: 'baoCaoVacxinDaGoi',
    component: baoCaoThongKeTiemVacxinDaGoi,
    props: true
  },
  {
    path: '/baoCaoTinhHinhSDVacXin',
    name: 'baoCaoTinhHinhSDVacXin',
    component: baoCaoThongKeTinhHinhSDVacxin,
    props: true
  },
  {
    path: '/baoCaoSanLocBenhKLNVaKSK',
    name: 'baoCaoSanLocBenhKLNVaKSK',
    component: baoCaoSanLocBenhKLNVaKSK,
    props: true
  },
  {
    path: '/donVi',
    name: 'DonViPage',
    component: DonViPage,
    props: true
  },
  {
    path: '/taoTaiKhoan',
    name: 'registerPage',
    component: registerPage,
    props: true
  },
  {
    path: '/dsTaiKhoan',
    name: 'userList',
    component: userList,
    props: true
  },
  {
    path: '/updatePasswordPage',
    name: 'updatePasswordPage',
    component: updatePasswordPage,
    props: true
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
